import React from 'react';
import { Box } from '@mui/material';
import ProjectTechFileListContainer from '../../../containers/techmng/techfiles/ProjectTechFileListContainer';
import ProjectTechMultiFileFormContainer from '../../../containers/techmng/techfiles/ProjectTechMultiFileFormContainer';

const ProjectTechFileTemplate = () => {
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <ProjectTechFileListContainer />
      <ProjectTechMultiFileFormContainer />
    </Box>
  );
};

export default ProjectTechFileTemplate;
